module.exports = __webpack_public_path__ + "img/aveny-tinstagram-medium-webfont.6d8e3637.svg";